var map = {
	"./china.svg": 263,
	"./circle_black.svg": 966,
	"./circle_blue.svg": 967,
	"./cn.svg": 968,
	"./ellipse_black.svg": 969,
	"./forgotpassword.svg": 319,
	"./france.svg": 264,
	"./highlighted_yellow.svg": 970,
	"./icons/_info.svg": 971,
	"./icons/add_prod.svg": 267,
	"./icons/add_prodOLD.svg": 972,
	"./icons/ask.svg": 973,
	"./icons/facebook.svg": 33,
	"./icons/hatchef.svg": 54,
	"./icons/icone/_info.svg": 974,
	"./icons/icone/hatchef.svg": 975,
	"./icons/icone/info.svg": 976,
	"./icons/icone/play.svg": 977,
	"./icons/icone/plus.svg": 978,
	"./icons/icone/specs.svg": 979,
	"./icons/icone/world.svg": 980,
	"./icons/index-icon-bookmark.svg": 981,
	"./icons/index-icon.svg": 413,
	"./icons/info.svg": 55,
	"./icons/markers-SVG/ask.svg": 982,
	"./icons/markers-SVG/info.svg": 983,
	"./icons/markers-SVG/list.svg": 984,
	"./icons/markers-SVG/recipe.svg": 985,
	"./icons/markers-SVG/web.svg": 986,
	"./icons/play.svg": 49,
	"./icons/play_ip.svg": 987,
	"./icons/plus.svg": 52,
	"./icons/promo.svg": 48,
	"./icons/promo2.svg": 988,
	"./icons/promo3.svg": 989,
	"./icons/promo_10.svg": 990,
	"./icons/promo_classic.svg": 991,
	"./icons/remove_prod.svg": 268,
	"./icons/remove_prodOLD.svg": 992,
	"./icons/shop_list.svg": 269,
	"./icons/specs.svg": 46,
	"./icons/whatsapp.svg": 34,
	"./icons/world.svg": 28,
	"./logo.svg": 993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 965;